import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=de438c0a&"
import script from "./Gateways.vue?vue&type=script&lang=js&"
export * from "./Gateways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xampp\\htdocs\\lifeline-donation-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de438c0a')) {
      api.createRecord('de438c0a', component.options)
    } else {
      api.reload('de438c0a', component.options)
    }
    module.hot.accept("./Gateways.vue?vue&type=template&id=de438c0a&", function () {
      api.rerender('de438c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Gateways.vue"
export default component.exports